export const translations = {
  'zh-TW': {
    translation: {
      addUser: '新增用戶',
      editUser: '編輯用戶',
      firstName: '名字',
      lastName: '姓氏',
      name: '名稱',
      role: '角色',
      status: '狀態',
      email: '電子郵件',
      phone: '電話',
      type: '類型',
      details: '詳情',
      nodes: '節點',
      roles: '角色',
      cancel: '取消',
      submit: '提交',
      delete: '刪除',
      create: '建立',
      deleteNodeError: '刪除節點時出錯',
      deleteConfirmation: '您確定要刪除嗎？',
      warning: '警告',
      Alert: '警報',
      deleteSure: '是的，我確定',
      nodesWillBeCreatedAt: '將於以下位置建立節點',
      searchFor: '搜尋',
      rolesError: '擷取角色時發生錯誤',
      userListError: '獲取用戶列表時出錯',
      organisationListError: '擷取組織清單時發生錯誤',
      loadingRoles: '正在載入角色…',
      selectRole: '選擇角色',
      validEmail: '請輸入有效的電子郵件地址',
      requiredEmail: '需要電子郵件信箱',
      resend: '重新發送',
      restrictedDomain: '受限制的電子郵件網域',
      addUserSuccess: '使用者新增成功',
      editUserSuccess: '使用者編輯成功',
      deleteUserSuccess: '用戶刪除成功',
      deleteModalAlertMessage:
        '您即將刪除使用者 {{userName}}。此使用者的所有權限將全數撤銷。',
      deleteProceedMessage: '你想繼續刪除嗎？',
      userAlreadyExist: '已存在使用此電子郵件 ID 的使用者。',
      addUserError: '無法新增使用者。請再試一次。',
      editUserError: '無法編輯使用者。請再試一次。',
      deleteUserError: '無法刪除使用者。請再試一次。',
      nodesError: '擷取指派的節點時發生錯誤',
      childNodesError: '載入階層級別時發生錯誤',
      hierarchyError: '擷取階層時發生錯誤',
      requestFailed: '請求失敗',
      emailSentSuccess: '成功傳送啟用電子郵件!',
      activationEmailError: '無法傳送啟用電子郵件。',
      activationEmailError1: '無法傳送啟動電子郵件。請稍後重試。',
      allOrganisations: '所有組織',
      address: '地址',
      hierarchyMetaError: '擷取階層詳細資料時發生錯誤',
      nodeMetaError: '載入節點詳細資料時發生錯誤',
      contactName: '聯繫人姓名',
      downloadTemplate: '下載模板',
      newOrg: '新組織',
      save: '保存',
      upload: '上傳',
      uploading: '正在上傳',
      dropExcel: '拖曳 Excel 工作表，或',
      browse: '瀏覽',
      importSettings: '匯入設定',
      addNodesSites: '新增新節點/站點',
      updateNodesSites: '更新現有節點/站台的資訊',
      disableNodesSites: '禁用不再存在的節點/站點',
      disabled: '禁用',
      new: '新',
      updated: '已更新',
      siteInstallation: '場址',
      addOrgSuccess: '組織創建成功！',
      excelUploadError: '無法儲存 Excel。請再試一次。',
      saveError: '無法儲存。請稍後再試。',
      saveBadRequestError: '無法儲存。可能是您嘗試儲存的資料發生問題。',
      telephone: '電話',
      externalIds: '外部 ID',
      contactEmail: '聯絡人電子郵件',
      longitude: '經度',
      latitude: '緯度',
      primaryContactName: '主要聯絡人姓名',
      primaryContactEmail: '主要聯絡人電子郵件',
      templateError: '下載範本時發生錯誤。請稍後再試一次',
      templateError1: '無法取得範本。請稍後再試。',
      home: '主頁',
      organisations: '組織',
      users: '使用者',
      lightTheme: '輕主題',
      darkTheme: '深色主題',
      login: '登入',
      logout: '登出',
      activateUserAcc: '啟動使用者帳戶',
      phoneNumber: '電話號碼',
      optional: '可選',
      password: '密碼',
      confirmPassword: '確認密碼',
      endUser: '使用者授權協議',
      iAccept: '我接受使用者授權合約。',
      iHereby: '我特此確認我已閱讀並接受',
      eula: '最終用戶許可協議',
      iRead: '我已閱讀 Honeywell 隱私權政策',
      iUnderstood: '是的，我已閱讀並理解',
      privacyPolicy: '隱私權政策',
      activate: '啟用',
      activationSuccess: '啟動成功',
      newAccAccess:
        '為了存取您的新帳戶，請使用您的新使用者名稱登入。此新使用者名稱如下所示：',
      emailSent: '新使用者名稱已傳送至您的電子郵件 ID。',
      signin: '登入',
      activationError: '啟用失敗',
      pleaseTryAgain: '請再試一次',
      activationExpired: '啟用權杖已過期',
      activationExpiredText:
        '這可能是因為電子郵件連結已逾時、已使用過或不正確。如果問題仍然存在，需請求新的啟用電子郵件。',
      contactSupport: '錯誤。請聯絡支援人員',
      pwdMatch: '密碼必須相符',
      required: '必填',
      eligiblePwd:
        '密碼必須包含至少 1 個大寫字母、1 個小寫字母、1 個數字、1 個特殊字元及最少 11 個字元',
      invalidPhoneNumber: '電話號碼無效',
      invalidName: '名稱不得超過 255 個字元，且前後不含空格',
      invalidFirstName: '名字包含無效字元。',
      invalidLastName: '姓氏包含無效字元。',
      timezone: '時區',
      timeZone: '時區',
      commissioningStatus: '委託狀態',
      countryCode: '國家/地區代碼',
      childCount: '子計素',
      sheetVersion: '工作表版本',
      unknownError: '發生未知的錯誤。請稍後再試。',
      preview: '預覽',
      file: '檔案',
      inCompatibleExcel: '檔案必須為 .xlsx 格式',
      selectOrg: '選擇組織',
      noRecordFound: '找不到任何記錄',
      total: '總計',
      items: '項目',
      forbidden: '禁止',
      noPermissionText: '您無權訪問此頁面',
      accessPermission: '請登入具有存取權限的帳戶',
      technicianExternalAccessPermission: '請登入手機應用程式',
      redirectToLogin: '重新導向至登入頁面',
      errorUserSettings: '獲取用戶設置時出錯',
      invalidSystemGuid: '無效的系統 GUID',
      languageNotSupported: '不支持語言',
      subscriptions: '訂閱',
      gatewayManagement: '網關管理',
      subscriptionNumber: '訂閱編號',
      orderNumber: '訂單編號',
      bundle: '套件組合',
      activatedOn: '啟用日期',
      order: '順序',
      editSubscription: '編輯訂閱',
      noNodeSelected: '未選擇節點',
      noUserSelected: '未選取使用者',
      loadingBundles: '正在載入套件組合…',
      bundlesError: '獲取捆綁包時發生錯誤',
      selectBundle: '選取套件組合',
      addSubscriptionSuccess: '訂閱已成功新增',
      addSubscriptionError: '無法新增訂閱。請再試一次。',
      subscriptionInputValidationError:
        '可以是帶有連字號的英數字值，且不得超過 13 個字元',
      errorUserGlobalPrivileges: '擷取使用者全域權限時發生錯誤',
      subscriptionAlreadyExist: '訂閱已存在。',
      invalidSubscription: '無效訂閱',
      Version: '版本',
      systemType: '系統類型',
      systemId: '系統 ID',
      reviewGatewayDetails: '檢閱閘道詳細資料',
      site: '場址',
      Organisation: '組織',
      gatewayRegistration: '閘道註冊',
      selectAnOrg: '選取組織',
      selectASite: '選擇一個站點',
      register: '註冊',
      selectSiteToRegsiter: '選取要註冊閘道的站台',
      gatewayRegistrationFailureMsg:
        '無法使用 Honeywell Sentience IOT 平台註冊閘道',
      gatewayRegistrationSuccessMsg:
        '已成功在 Honeywell Sentience IOT 平台註冊閘道',
      siteEmptyMsg: '{{- orgName}} 組織的所有站點都已註冊',
      forgeOnboarding: '組織映射',
      SiteFetchingFailure: '無法從 Forge 擷取站點',
      selectAllSitesText: '選取所有 Forge 站點以上線遠端建築管理工具',
      onBoardingFailure: '上線期間無法啟用站點',
      customerID: '客戶 ID',
      enterCustomerID: '輸入客戶 ID',
      loadingSites: '正在載入站點…',
      fetchSites: '擷取站點',
      subscriptionActivateSuccess: '"{{siteName}} 的訂閱已成功啟用',
      subscriptionActivateError: '因技術問題無法啟用，請聯絡您的管理員',
      activateNow: '立即啟用',
      multiSiteSuccess: '已成功新增站點。',
      onboardSelected: '上線已選取',
      sitePartialSuccess:
        '因技術問題，部分站點無法上線。請再試一次或聯絡您的管理員。',
      confirm: '確認',
      onboardingFailed: '上線失敗',
      failed: '失敗',
      onboardedSuccessfully: '網站已上線',
      notOnboarded: '未上線',
      onboarding: '正在上線…',
      reOnboard: '重新上線',
      selectAll: '全選',
      siteSuccess: '網站已添加成功。',
      dataloseWarning: '請不要在網站上線時刷新頁面。',
      addServiceSuccess: '已成功新增服務',
      addServicesText: '新增服務',
      validityText: '有效期',
      invalidInputError: '輸入無效',
      subsactivateError: '訂閱已啟用',
      subsnotfoundError: '找不到訂閱詳細資料',
      invalidorderError: '訂單編號無效',
      bundnotfoundError: '找不到套件組合詳細資料',
      subscribedServices: '已訂閱服務',
      subsactivateSuccess: '已成功建立並啟用訂閱',
      subsactivateFailure: '訂閱已建立，但啟用失敗。請再試一次！！',
      subsactivateDiffSite: '已為另一個站點啟用訂閱',
      gatewayAssociation: '閘道關聯',
      systemGuid: '系統 GUID',
      success: '成功',
      contactSystemAdministrator: '請聯繫您的系統管理員',
      siteName: '場址名稱',
      location: '位置',
      action: '操作',
      addNewSite: '新增網站',
      add: '新增',
      sitesAssociated: '{{siteCount}} 站點已關聯',
      numberOfAddon: '附加元件數量',
      searchSite: '搜尋站點',
      noResultFound: '找不到結果',
      noDataFound: '未找到數據',
      loadMore: '載入更多內容',
      unlinkMessage:
        '若要從 {{sku}} 解除 {{siteName}}，請致電 Honeywell 客戶服務中心 (+01 480-353-3020)，或傳送電子郵件至 support@honeywell.com',
      associatedOrderNumber: '相關訂單編號',
      associatedSubscriptionNumber: '相關訂閱號碼',
      helperTextSKU: '要修改訂閱號碼，請聯繫',
      helperOrderTextSKU: '要修改訂單號，請聯繫',
      customerCare: '客戶服務',
      skuDetails: 'SKU 詳細信息',
      manageSites: '管理站點',
      skuName: 'SKU 名稱',
      skuDescription: 'SKU 描述',
      licenseUtilization: '許可證使用情況',
      validTill: '有效期限至',
      editSKU: '編輯 SKU',
      duplicateSiteError: '網站已添加',
      numberOfAddonRequired: '請輸入插件數量',
      siteFetchError: '擷取站點清單時發生錯誤',
      siteSuccessMsg: '已成功新增網站',
      siteFailedMsg: '無法新增站點',
      problemWithRequest: '請求發生問題。',
      newSubscriptionAdded: '新的已新增訂閱',
      licensesOf: '的授權',
      all: '全部',
      orderPlacedBy: '訂單下達人',
      pendingRenewal: '待續約',
      daysRemaining: '剩餘天數',
      renewSubscriptionMessage:
        '若要續訂 {{skuName}}，請致電 Honeywell 客戶服務中心 (+01 480-353-3020)，或傳送電子郵件至 support@honeywell.com',
      columnSelection: '欄位選擇',
      selectUpTo: '您最多可以選取',
      itemsToDisplay: '要在表格中顯示的項目。',
      subscriptionManagement: '訂閱管理',
      activated: '已啟用',
      warningHeader: '你確定要取消嗎？',
      warningMessage: '尚未儲存的變更可能會遺失',
      renewSubscription: '續訂訂閱',
      pendingActivation: '待激活',
      notAuthorizedError: '您無權將 SKU 指派給此組織',
      gatewayRegistrationInProgress: '{{gateway}} 進行中',
      gatewayAssociationFailed:
        '請檢查閘道連線並重試。如果再次失敗，請聯絡您的系統管理員。',
      gatewayRegistrationFailed: '請重試。如果再次失敗，請聯絡您的系統管理員。',
      doAssociationMessage: '請檢查閘道連線，然後繼續進行閘道關聯。',
      errorInAssociation: '處理關聯時出錯。',
      association: '關聯',
      dataloseWarningForRegistration:
        '閘道註冊正在進行中，可能需要幾分鐘的時間。請勿重新整理，以免資料遺失。',
      dataloseWarningForAssociation:
        '閘道關聯正在進行中，可能需要幾分鐘的時間。請勿重新整理，以免資料遺失。',
      objectName: '對象名稱',
      objectType: '對象類型',
      unitName: '單位',
      bitunpack: '位元解壓縮',
      bitRange: '位元範圍',
      propName: '屬性名稱',
      propDataType: '資料類型',
      propValue: '屬性值',
      msgType: '訊息類型',
      isMultiState: '為多狀態',
      scalingOperation: '縮放操作',
      scalingFactor: '比例因子',
      byteOrder: '位元組順序',
      propertyName: '屬性名稱',
      addTemplateSuccess: '已成功新增範本',
      addTemplateError: '無法新增範本。請再試一次。',
      updateTemplateSuccess: '已成功更新範本',
      updateTemplateError: '無法更新範本。請再試一次。',
      outOfRangeError: '值必須介於 {{min}} 和 {{max}} 之間',
      requiredField: '請填寫所有欄位',
      templateName: '範本名稱',
      modelName: '型號名稱',
      vendorName: '供應商名稱',
      uniqueValueError: '值必須是唯一的',
      templateMangement: '範本管理',
      equipmentType: '設備類型',
      selectType: '選擇類型',
      listOfTemplate: '範本清單',
      selectTemplate: '選取範本',
      ElectricityVoltage: '電壓',
      ElectricityCurrent: '電流',
      ElectricPowerFactor: '電力因數',
      ElectricFrequency: '電頻率',
      EnergyReceived: '接收到的能量',
      ActivePower: '有功功率',
      ActivePowerA: '有效功率 A',
      ActivePowerB: '有效功率 B',
      ActivePowerC: '有效功率 C',
      ReactivePower: '無功功率',
      ApparentPower: '視在功率',
      PeakDemand: '需求高峰',
      ElectricityCurrentA: '電流 A',
      ElectricityCurrentB: '電流 B',
      ElectricityCurrentC: '電流 C',
      ElectricityVoltageA: '電壓 A',
      ElectricityVoltageB: '電壓 B',
      ElectricityVoltageC: '電壓 C',
      ElectricityConsumption: '用電量',
      loaderWelcomeMessage: '歡迎來到上線入口網站。請稍候。',
      latitudeAndLongitude: '緯度和經度',
      siteUpdateSuccessMessage: '站點詳細資訊已成功更新',
      siteUpdateErrorMessage: '更新網站詳細資料時出錯',
      provisioningFailedMessages: '站點配置失敗。請重試',
      onboardAllSites: '上線所有站點',
      geoCordinatesErrorMsg: '請驗證座標',
      tooltipCordinateMessage: '座標必須介於',
      emptyValueMessage: '不允許空值',

      browseFile: '瀏覽檔案',
      fileTypeErrorMsg: '不允許檔案類型',

      orgImgTitle: '上傳組織標誌',
      orgImgDropTxt: '拖放標誌',
      orgImgInfoTxt:
        '寬 {{width}} 像素 X 高 {{height}} 像素，且僅限 *.png 檔案格式',
      orgImgPreviewTxt: '預覽標誌',
      orgImgTooltipTxt: '標誌具有透明背景，且應與黑色標題背景形成對比',
      orgImgSizeOfErrorMsg:
        '圖像大小應為最大寬度 {{width}}px、最大高度 {{height}}px、最小寬度 {{minWidth}}px、最小高度 {{minHeight}}px 和最大尺寸 {{maxSize}}kb',

      siteImgTitle: '上傳站點影像',
      siteImgDropTxt: '拖放建築影像 (*.png 或 .jpg)',
      siteImgPreviewTxt: '預覽站點詳細資料頁面',
      siteTooltipTxt:
        '根據不同的顯示器分辨率，圖像的左右將裁剪 46 像素，頂部和底部裁剪 30 像素',
      siteImgInfoTxt:
        '寬 {{width}} 像素 X 高 {{height}} 像素及 *.png 與 *.jpg 檔案格式',
      siteImgSizeOfErrorMsg:
        '圖像大小應為最大寬度 {{width}}px、高度 {{height}}px 和大小 {{maxSize}}kb',
      orTxt: '或者',
      addLogo: '添加標誌',
      addImage: '添加圖像',
      imageUploadSuccess: '圖片上傳成功',
      alertnteId: '備用用戶名：',
      username: '使用者名稱：',
      errorFetchingUser: '獲取用戶詳細信息時出錯',
      errorFetchingRoles: '擷取角色時發生錯誤',

      gateway: '網關',
      associateAndSyncBtn: '關聯和同步',
      cancelBtn: '取消',
      guidValidationError: 'GUID 驗證錯誤',
      gatewayId: '閘道 ID',
      addNewGateway: '新增網關',
      successMessage1: '站點關聯，已完成',
      successMessage2: '站點關聯，已完成。將啟用模型同步',
      errorMessage: '關聯失敗，將不會啟動模型同步',
      importUsers: '匯入使用者',
      importUsersSubHeading: '下載 CSV 範本以新增和管理您要匯入的內容。',
      dropCsvHere: '將文件拖放到此處或',
      browsrForFiles: '瀏覽檔案',
      subHeadingBrowser: '僅接受 CSV 檔案，且此檔案不應超過 5 MB。',
      subHeadingBrowserTwo: '(一次只能上傳一個)',
      userUploadSuccess: '資料已成功傳送',
      userUploadProcessing:
        '已成功上傳資料。我們目前正在處理中，將需要幾分鐘的時間。我們會盡快提供您更新資訊。',
      fileNameDisplay: '檔案名稱：',
      fileName: '檔案名稱',
      errorNotification:
        '我們在上傳模板時遇到了問題，請糾正以下錯誤並重新上傳模板。',
      errorHeading: '錯誤',
      slnumber: '序號',
      errorMessageHeading: '錯誤訊息',
      endUserAgreement: 'Honeywell Forge 條款',
      privacyStatement: '隱私權聲明',
      yourPrivacyChoices: '您的隱私選擇',
      cookieNotice: 'Cookie 聲明',
      dataCentre: '數據中心',
      isForgeText: '建築物',
      gatewayIdleMessage: '您已閒置一段時間，請重新整理此頁面並繼續',
      refresh: '重新整理',
      landingLogin: '按一下此處',
      loginUserIntegratorRole: 'BA 電商用戶',
      loginUserCustomerRole: '所有其他使用者',
      loginWelcomeNote: '歡迎，請在下面選擇您的角色以開始。',
      termsAndConditions: '條款及細則',
      accept: '接受',
      legalPatentInformation: '專利權法律資訊',
      onboardingPortal: '上線入口網站',
      customers: '客戶',
      templates: '範本',
      assetModelling: '資產建模',
      selectCustomer: '選擇客戶',
      integration: '整合',
      integrationSubtitle: '無縫整合以獲得即時效能洞察分析',
      customer: '顧客',
      accessibleCustomersError: '擷取可存取客戶時發生錯誤',
      workflows: '工作流程 (Legacy)',
      apiCredentials: 'API 憑證',
      integrationsTab: '工作流程',
      noSubscription: '未發現有效訂閱。請訂閱以使用此功能。',
      loading: '載入中...',
      licenseManagement: '授權管理',
      activityLogTitle: '活動日誌',
      activityLogSubtitle: '追蹤特定客戶的工作流程事件與狀態更新',
      activityLogSidebarTitle: '活動日誌',
      activityLogSidebarSubtitle: '以下是您所有客戶組織的活動數據',
      activityLogListTitle: '活動列表',
      activityLogSearchPlaceholder: '按活動、網站搜尋',
      activityLogLastUpdated: '上次更新時間',
      activityLogCreatedOn: '建立於',
      activityLogActivity: '活動',
      activityLogSite: '場址',
      activityLogStatus: '狀態',
      activityLogCreatedBy: '建立者',
      activityLogUpdatedBy: '更新者',
      activityLogNameUnavailable: '無可用名稱',
      activityLogUserNamesError: '無法載入 創建者/更新者 名稱',
      activityLogStatusSuccess: '成功',
      activityLogStatusFailed: '失敗',
      activityLogStatusInProgress: '進行中',
      activityLogStatusQueued: '已排入佇列',
      activityLogStatusPending: '待處理',
      activityLogStatusSkipped: '已跳過',
      activityLogPaginationInfo:
        '{startItem} - {endItem} 個，共 {totalItems} 個項目',
      activityLogPageGoTo: '前往頁面',
      activityLogRowPerPage: '每頁行數',
      activityLogRetry: '重試',
      activityLogRetrying: '重試中...',
      activityLogRetrySuccess: '已成功啟動任務重試。',
      activityLogRetryError: '任務重試失敗。請再試一次。',
      activityLogRetryAllSuccess: '所有任務皆已成功重試。',
      activityLogRetryAllFailed: '所有重試都失敗了。請再試一次。',
      activityLogRetryPartialFailed: '有些任務無法重試。請再試一次。',
      activityLogLoading: '正在加載詳細資訊...',
      activityLogFetchError: '無法載入活動資料。請再試一次。',
      activityLogModalClose: '關閉',
      activityLogModalTasks: '任務',
      activityLogModalCreatedOn: '建立於',
      activityLogModalLastUpdatedOn: '上次更新時間',
      activityLogModalSupportNote: '關於失敗事件的描述以及原因代碼。',
      activityLogModalSupportReach: '如需協助，請聯絡',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: '篩選條件',
      noCustomersAvailable: '沒有可用的客戶',
      activityLogFilterStatus: '狀態',
      activityLogFilterActivity: '活動',
      activityLogFilterSite: '場址',
      activityLogFilterCreatedBy: '建立者',
      activityLogFilterApply: '套用',
      activityLogFilterReset: '重設',
      activityLogFilterNoOptions: '無可用選項',
      activityLogFilterError: '無法載入過濾器選項。請再試一次。',
      search: '搜尋',
      more: '更多',
      noResults: '找不到結果',
      activityLogCustomizeColumns: '自訂列',
      activityLogColumnsReorder: '重新排序',
      activityLogColumnsAddRemove: '新增/移除',
      activityLogColumnsReorderDescription: '調整位置即可變更資料表的欄位順序',
      activityLogColumnsAddRemoveDescription: '勾選欄位以便顯示在表格中',
      activityLogDetails: '詳情',
      activityLogFiltersChanged:
        '未找到符合所選篩選條件的資料。請調整或重設篩選條件以查看結果。',
      activityLogResetFilters: '重設篩選條件',
      activityLogSiteState: '狀態',
      activityLogSiteCity: '城市',
      workflowTaskCBCustomerCreation: '建立 CB 客戶',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        '合作夥伴入口網站的入職狀態更新',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        '在合作夥伴入口網站中更新 CB 客戶 ID',
      workflowTaskEOMCustomerCreation: '建立 EOM 客戶',
      workflowTaskOnboardCustomerForAI: '啟動客戶 AI 上線流程',
      workflowTaskDeleteCustomerInCBPortal: '在 CB 入口網站刪除客戶',
      workflowTaskUpdateCustomerInCBPortal: '在 CB 入口網站中更新客戶',
      workflowTaskUpdateCustomerInEOM: '更新客戶在 EOM 中',
      workflowTaskUpdateCustomerInAssetModelling: '在資產建模中更新客戶',
      workflowTaskTrackScanStatusFileAttachment: '追蹤檔案附件的掃描狀態',
      workflowTaskCBSiteCreation: '建立 CB 站點',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        '在合作夥伴入口網站中更新 CB 站點 ID',
      workflowTaskEOMSiteCreation: 'EOM 網站建立',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        '在合作夥伴入口網站中更新 EOM 站點 ID',
      workflowTaskSyncExistingUsersCBPortal: '將現有使用者同步到 CB 入口網站',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        '更新合作夥伴入口網站的使用者同步狀態',
      workflowTaskCalculateEnergySavingsPotential: '計算節能潛力',
      workflowTaskDeleteSiteInCBPortal: '在 CB 入口網站刪除網站',
      workflowTaskDeleteSiteInEOM: '在 EOM 中刪除網站',
      workflowTaskUpdateSiteInCBPortal: '在 CB 入口網站中更新站點',
      workflowTaskUpdateSiteInEOM: '在 EOM 中更新站點',
      workflowTaskUpdateSiteInAssetModelling: '更新資產建模中的站點',
      workflowTaskUpdateSiteInFindAPI: '在 Find API 功能中更新站點',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        '將訂閱關聯同步到 CB 入口網站',
      workflowTaskEnableBrickOntology: '啟用 Brick 本體架構',
      workflowTaskOnboardCustomerForgeAPI: '將客戶上線至 ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        '將 ForgeAPI 上線狀態發佈至憑證管理',
      workflowTaskAddUserInCBPortal: '在 CB 入口網站新增使用者',
      workflowTaskUpdateUserProvisioningStatus: '更新使用者配置狀態',
      workflowTaskDeleteUserInCBPortal: '在 CB 入口網站刪除使用者',
      workflowTaskUpdateUserDeletionStatus: '更新使用者刪除狀態',
      workflowCustomerCreation: '建立客戶',
      workflowCustomerDelete: '刪除客戶',
      workflowCustomerUpdate: '在 EOM 更新客戶',
      workflowFileAttachmentsScan: '檔案附件掃描狀態',
      workflowSiteCreation: '建立站點',
      workflowSiteDelete: '刪除站點',
      workflowSiteUpdate: '更新站點',
      workflowSubscriptionAssociation: '訂閱關聯',
      workflowAddUser: '新增用戶',
      workflowDeleteUser: '刪除使用者',
      workflowNamePlate: '銘牌',
      workflowForgeAPIOnboarding: 'Forge API 上線',
      workflowAddUserMultiple: '新增多個使用者工作流程',
      workflowDeleteUserMultiple: '刪除多個使用者工作流程',
      workflowModelFileUpload: '模型檔案上傳',
      workflowGatewayAssociation: '閘道關聯',
      workflowIntegrationRegistered: '整合已註冊',
      workflowTaskForgeAPIOnboardingStatus: 'Forge API 上線狀態',
      workflowTaskAddUser: '新增使用者工作流程',
      workflowTaskProcessModelFile: '流程模型檔案',
      workflowTaskNotifyAssetModelling: '通知資產建模',
      workflowTaskAssociateGateway: '關聯閘道至站點',
      workflowTaskFetchModelToAssetModelling: '擷取模型至資產建模',
      workflowTaskNameProcessNamePlate: '資產名稱牌檔案。',
      workflowTaskUpdateModelInFindAPI: '在 Find API 功能中更新模型',
      workflowTaskProcessIntegrationRegistered: '處理整合註冊完成',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        '處理 DF 通知（整合已註冊）',
      workflowTaskTenantOnboardingAFO: '租戶啟用至 AFO',
      workflowTaskOnboardCustomerCDL: '啟動客戶 CDL 上線流程',
      workflowTaskPublishAFOOnboardingStatus: '將 AFO 上線狀態發布至規則建構器服務',
      activityLogCorrelationId: '關聯 ID',
      activityLogTaskId: '作業 ID',
      activityLogToastSuccess: '成功',
      activityLogToastError: '錯誤',
      activityLogIteration: '疊代',
      activityLogFieldFirstName: '名字',
      activityLogFieldLastName: '姓氏',
      activityLogFieldSubscriptionName: '訂閱名稱',
      activityLogFieldName: '名稱',
      activityLogFieldCurrency: '貨幣',
      activityLogFieldZip: '郵遞區號',
      activityLogFieldArea: '區域',
      activityLogFieldCity: '城市',
      activityLogFieldState: '狀態',
      activityLogFieldCountry: '國家',
      activityLogFieldAreaUnit: '面積單位',
      activityLogFieldLanguage: '語言',
      activityLogFieldLatitude: '緯度',
      activityLogFieldSiteType: '網站類型',
      activityLogFieldTimezone: '時區',
      activityLogFieldLongitude: '經度',
      activityLogFieldCountryCode: '國家/地區代碼',
      activityLogFieldSiteId: '站點 ID',
      activityLogFieldFileType: '檔案類型',
      activityLogFieldReason: '原因',
      activityLogFieldCustomerSupportEmails: '客戶支援電子郵件',
      activityLogFieldAddressLine1: '地址第 1 行',
      activityLogFieldAddressLine2: '地址第 2 行',
      activityLogFieldContactEmail: '聯絡人電子郵件',
      activityLogSiTitle: '活動日誌',
      support: '支援',
      projectManagement: '專案管理',
    }
  }
};
